
































































































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { User } from "@/models/user_schema";
import { Address } from "@/models/address";

import SalesRegionMap from "@/models/map/region";
import RepService from "../../services/rep_service";
import states from "@/map_data/state-abbrv";
import provinces from "@/map_data/prov-abbrv";
import { StoreModule } from "@/store/types";
import { RepActions } from "@/store/modules/rep/types";
import { namespace } from "vuex-class";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { phone } from "@/validators/custom";
import { Validation } from "vuelidate";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import { UserGetters } from "@/store/modules/user/types";
import { Roles } from "@/models/roles";

@Component
export default class ModalRep extends Vue {
  @Prop() isEdit!: boolean;
  @Prop() data!: User;
  protected formData = { address: {} as Address, rep_info: {} as User["rep_info"] } as any;
  protected salesRegions: string[] = [];
  protected repService = new RepService();
  protected country = "USA";
  protected $v: Validation;
  protected Roles = Roles;
  protected mfrs_carried = "";
  @(namespace(StoreModule.Rep).Action(RepActions.AddRep)) addRep;
  @(namespace(StoreModule.Rep).Action(RepActions.EditRep)) editRep;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;

  @Validations()
  validations() {
    return {
      country: { required },
      formData: {
        first_name: { required },
        last_name: { required },
        email: { required, email },
        phone: { required, phone },
        rep_info: {sales_region: { required }}        ,
        address: {
          address_1: { required },
          city: { required },
          state: { required },
          postal_code: { required },
        },
      },
    };
  }

  created() {
    this.setSalesRegionArray();
    this.prepFormData();
  }
  
  public prepFormData(): void {
    if (this.isEdit) {
      this.formData = { ...this.data } as User;
      this.formData.address = {...this.data.address![0]};
    }
    if (!this.formData.address.country) {
      this.country = "USA";
    } else {
      this.country = this.formData.address.country;
    }
  }

  public setSalesRegionArray(): void {
    SalesRegionMap.forEach((key) => {
      this.salesRegions.push(key);
    });
  }

  public handleSubmit(): void {
    this.$v.formData.$touch();
    if (!this.$v.$invalid) {
      this.submit();
    }
  }

  public get states(): string[] {
    let list;
    if (this.country === "Canada") {
      list = provinces;
    } else {
      list = states;
    }
    return list;
  }

  public get zipMask(): string {
    let mask;
    if (this.country === "Canada") {
      mask = "A#A #A#";
    } else {
      mask = "#####";
    }
    return mask;
  }

  public handleMfrs(): string[] {
    const strings = this.mfrs_carried.split(",");
    return strings.map((string) => {
      return string.trim();
    });
  }

  public async submit(): Promise<void> {
    this.formData.address.country = this.country;
    if (this.mfrs_carried) {
      this.formData.mfrs_carried = this.handleMfrs();
    } else {
      this.formData.mfrs_carried = [];
    }
    if (this.isEdit) {
      try {
        await this.editRep(this.formData);
        this.editRep(this.formData);
        this.$emit("close");
      } catch (err) {
        if (err instanceof AuthError) {
          AuthError.logout();
        } else if (err instanceof APIError) {
          APIError.popup(err.message);
        } else {
          GenericError.popup(err.message);
        }
      }
    } else {
      try {
        const res = await this.repService.createNewRep(this.formData);
        this.addRep(res);
        this.$emit("close");
      } catch (err) {
        if (err instanceof AuthError) {
          AuthError.logout();
        } else if (err instanceof APIError) {
          APIError.popup(err.message);
        } else {
          GenericError.popup(err.message);
        }
      }
    }
  }
}
